import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ExpenseForm = _resolveComponent("ExpenseForm")
  const _component_ExpenseFormProvider = _resolveComponent("ExpenseFormProvider")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    "set-close": _ctx.setClose,
    onClose: _cache[2] || (_cache[2] = $event => (_ctx.closeModal($event)))
  }, {
    default: _withCtx(() => [
      _createVNode("div", {
        class: { 'w-200': _ctx.hideSidebar, 'w-250': !_ctx.hideSidebar }
      }, [
        _createVNode(_component_ExpenseFormProvider, {
          "budget-cycle": _ctx.budgetCycle,
          data: _ctx.data,
          "edit-mode": _ctx.editMode,
          type: _ctx.type,
          "hide-sidebar": _ctx.hideSidebar,
          "onClose-modal": _cache[1] || (_cache[1] = $event => (_ctx.setCloseModal($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ExpenseForm)
          ]),
          _: 1
        }, 8, ["budget-cycle", "data", "edit-mode", "type", "hide-sidebar"])
      ], 2)
    ]),
    _: 1
  }, 8, ["show", "set-close"]))
}